package com.eladfinish.bible.contest.network.error.utils

import kotlinx.browser.window

// What a failed fetch() is called: ktor's JS engine ("Fail to fetch"), Chrome ("Failed to fetch"),
// Firefox ("NetworkError when attempting to fetch resource") and Safari ("Load failed").
private val fetchFailureMessages = listOf("Fail to fetch", "Failed to fetch", "NetworkError", "Load failed")

/**
 * A browser gives no typed "no connection" exception: a request that never reached a server
 * surfaces as a generic error carrying one of [fetchFailureMessages], possibly wrapped. Anything
 * that fails while the browser itself reports being offline counts too.
 */
actual fun Throwable.isInternetError(): Boolean {
    if (!window.navigator.onLine) return true
    return generateSequence(this) { it.cause }
        .take(10)
        .any { throwable ->
            val message = throwable.message.orEmpty()
            fetchFailureMessages.any { it in message }
        }
}
